<script setup lang="ts">
import AppShell from "@/components/layout/AppShell.vue";
</script>

<template>
  <AppShell>
    <router-view />
  </AppShell>
</template>
